import { PointOfSaleOutlined } from '@mui/icons-material';
import { ReactNode } from 'react';
import { Role } from '../../enums/Role';
import { System } from '../../enums/System';

export interface IntegrationDefinition {
  id: string;
  titleKey: string;
  descriptionKey: string;
  path: string;
  permissions: Role[];
  systemIds: System[];
  icon: ReactNode;
}

export const integrationCatalog: IntegrationDefinition[] = [
  {
    id: 'lightspeed',
    titleKey: 'lightspeedIntegration',
    descriptionKey: 'lightspeedDescription',
    path: '/integrations/lightspeed',
    permissions: ['LightspeedConnectionManage'],
    systemIds: [System.OrderlyForStores],
    icon: <PointOfSaleOutlined />,
  },
];

export const integrationPermissions: Role[] = Array.from(new Set(integrationCatalog.flatMap(item => item.permissions)));
export const integrationSystemIds: System[] = Array.from(new Set(integrationCatalog.flatMap(item => item.systemIds)));
